import * as d3 from 'd3';
export const defaultFormat = d3.format('.2f');
